import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Popup({
  isOpen,
  onClose,
  title,
  children
}: PopupProps) {
  const popupRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Handle clicking outside to close
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    // Handle ESC key to close
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscKey);
      // Prevent body scrolling when popup is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-122" data-mp="2855j2fx6q3tv">
      <div ref={popupRef} className="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto" data-id="element-123" data-mp="2d2xbrc5nltz4">
        <div className="flex justify-between items-center p-5 border-b border-gray-100" data-id="element-124" data-mp="30ucjjkg793hr">
          <h3 className="text-xl font-bold text-gray-800" data-id="element-125" data-mp="35snvc0q21o2m">{title}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 focus:outline-none" data-id="element-126" data-mp="2r3hyukilqbyf">
            <XIcon className="h-5 w-5" data-id="element-127" data-mp="2w2ba06af1qvf" />
          </button>
        </div>
        <div className="p-5" data-id="element-128" data-mp="2w0i10kcbyuk9">{children}</div>
      </div>
    </div>;
}